// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"layout_Wrapper__niSep","Header":"layout_Header___aZmv","Mobile":"layout_Mobile__vawX3","Page":"layout_Page__VIRKJ","Content":"layout_Content__J6AUz"};